export default __webpack_public_path__ + "static/media/logo_btib.f83b836b.png";